"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;

var _react = _interopRequireDefault(require("react"));

var _useHeaderMenu = require("../useHeaderMenu");

var _UiComponents = require("./UiComponents");

var _Icons = require("./Icons");

var _core = require("@emotion/core");

var App = function App() {
  var _ref = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref2 = _slicedToArray(_ref, 2),
      handleDispatchMenuEvents = _ref2[1].handleDispatchMenuEvents;

  return (0, _core.jsx)(_UiComponents.Container.App, null, (0, _core.jsx)(_UiComponents.Layout.Flex, null, (0, _core.jsx)("div", null, "Mais praticidade? Baixe nosso app:")), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    justifyContent: ""
  }, (0, _core.jsx)(_UiComponents.Layout.Box, {
    as: "a",
    rel: "noopener",
    href: "https://creditasapp.onelink.me/q3aj/2b00ceb0",
    target: "_blank",
    margin: "0 16px 0 0",
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: 'outbound links | baixe nosso app',
        label: 'app store | https://creditasapp.onelink.me/q3aj/2b00ceb0'
      });
    }
  }, (0, _core.jsx)(_Icons.Apple, null)), (0, _core.jsx)(_UiComponents.Layout.Box, {
    as: "a",
    rel: "noopener",
    href: "https://creditasapp.onelink.me/q3aj/228374b2",
    target: "_blank",
    margin: "0 16px 0 0",
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: 'outbound links | baixe nosso app',
        label: 'google play | https://creditasapp.onelink.me/q3aj/228374b2'
      });
    }
  }, (0, _core.jsx)(_Icons.Google, null))));
};

exports.App = App;
App.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "App"
};